/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect, useRef } from "react";
import { Dialog } from "primereact/dialog";
import { Toast } from "primereact/toast";

//*************** Libreria para realizar pdfs************************************* */
import pdfMake from "pdfmake/build/pdfmake";
import pdfFonts from "pdfmake/build/vfs_fonts";
import { PDFDocument } from "pdf-lib";

// ------------------ COMPONENTES DE BASE--------------------------
import { formatNumberDecimal } from "../../../../../../Base/Services/FormatTemplate";
import { getLabel } from "../../../../../../Base/Services/Language/LanguageService";
import { getDateString } from "../../../../../../Base/Services/Moment/Luxon";
import Loader from "../../../../../../Base/Components/Loader/Loader";
import { getInformacionEmpresa } from "../../../../../../Base/API/Global/InformacionEmpresa/InformacionEmpresaRequest";


// ------------------- CONSULTAS A LA API---------------------------
import { getFirmaPersonal } from "../../../../../../API/Payrolls/Firmas/FirmasRequests";
import { ObtenerDetalleRequisaReporte, ObtenerEncabezadoRequisaSinE } from "../../../../../../API/Suministros/IngresosMateriales/IngresosMaterialesRequest";

// ------------------ COMPONENTES DE NECESARIOS--------------------------
import { RequisasMaterialesReporteLang } from "./RequisasMaterialesReporteLang";
import JsBarcode from 'jsbarcode';


import QRCode from 'qrcode';

pdfMake.vfs = pdfFonts.pdfMake.vfs;

const ReporteRM = ({
    showReporte,
    setShowReporte,
    selectedDetalle,
    setSelectedDetalle,
    getInfo,
    Language,
    setLanguaje
}) => {
    const [loading, setLoading] = useState(true);
    const [pdfRequisa, setPdfRequisa] = useState([]);
    const [pdfUrlCombinado, setPdfUrlCombinado] = useState(null);
    const toast = useRef(null);

    const obtenerImagenPDF = (img) => {
      if (!img || typeof img !== "string") return null;

      const limpia = img.trim();

      if (
        !limpia ||
        limpia === "null" ||
        limpia === "undefined" ||
        limpia.startsWith("http")
      ) {
        return null;
      }

      if (limpia.startsWith("data:image/")) {
        return limpia;
      }

      const esBase64 = /^[A-Za-z0-9+/]+={0,2}$/.test(limpia);

      if (!esBase64) return null;

      return `data:image/png;base64,${limpia}`;
    };

    const obtenerInformacion = async () => {
      try {
        setLoading(true);

        if (!selectedDetalle || selectedDetalle.length === 0) {
          return;
        }

        const infoEmpresaTempo = await getInformacionEmpresa();

        const name = infoEmpresaTempo[0]?.NombreLegal;
        const direccion = infoEmpresaTempo[0]?.Direccion;
        const logoB64 = obtenerImagenPDF(infoEmpresaTempo[0]?.LogoPrimarioB64);
        console.log("Logo original:", infoEmpresaTempo[0]?.LogoPrimarioB64);
console.log("Logo PDF:", logoB64);

        const pdfsGenerados = [];

        for (const item of selectedDetalle) {
          const encabezadoTempo = await ObtenerEncabezadoRequisaSinE(item?.Requisa);
          const detallesTempo = await ObtenerDetalleRequisaReporte(item?.Requisa);

          let liberarGerenteSolicita = null;
          let tecnico = null;
          let RRHHAuth = null;
          let MASSAuth = null;
          let imgBlanca = null;

          let cantidadFirmas = 0;
          let necesitaFirmaRRHH = false;
          let necesitaFirmaMASS = false;

          let solicitaArray = [];
          let RRHHArray = [];
          let MASSArray = [];

          if (detallesTempo.length > 0) {
            const algunoDetallesSolicita = detallesTempo.some((detalle) => detalle.Solicita === 1);
            const algunoDetallesRRHH = detallesTempo.some((detalle) => detalle.RRHH === 1);
            const algunoDetallesMASS = detallesTempo.some((detalle) => detalle.MASS === 1);

            necesitaFirmaRRHH = detallesTempo.some((detalle) => detalle.PermisoSalidaBodegaRRHH === true);
            necesitaFirmaMASS = detallesTempo.some((detalle) => detalle.PermisoSalidaBodegaMASS === true);

            imgBlanca = await getFirmaPersonal("111");

            if (necesitaFirmaRRHH) cantidadFirmas++;
            if (necesitaFirmaMASS) cantidadFirmas++;

            if (detallesTempo[0]?.IdPersonalAutorizoSolicita && algunoDetallesSolicita) {
              liberarGerenteSolicita = await getFirmaPersonal(detallesTempo[0].IdPersonalAutorizoSolicita);
            }

            if (detallesTempo[0]?.Idtecnico) {
              tecnico = await getFirmaPersonal(detallesTempo[0].Idtecnico);
            }

            if (detallesTempo[0]?.IdPersonalAutorizoRRHH && algunoDetallesRRHH) {
              RRHHAuth = await getFirmaPersonal(detallesTempo[0].IdPersonalAutorizoRRHH);
            }

            if (detallesTempo[0]?.IdPersonalAutorizoMASS && algunoDetallesMASS) {
              MASSAuth = await getFirmaPersonal(detallesTempo[0].IdPersonalAutorizoMASS);
            }
          }

          detallesTempo.forEach((detalle) => {
            solicitaArray.push(detalle.Solicita);
            RRHHArray.push(detalle.PermisoSalidaBodegaRRHH);
            MASSArray.push(detalle.PermisoSalidaBodegaMASS);
          });

          liberarGerenteSolicita = obtenerImagenPDF(liberarGerenteSolicita);
          tecnico = obtenerImagenPDF(tecnico);
          RRHHAuth = obtenerImagenPDF(RRHHAuth);
          MASSAuth = obtenerImagenPDF(MASSAuth);
          imgBlanca = obtenerImagenPDF(imgBlanca);
          console.log("Firmas PDF:", {
            liberarGerenteSolicita,
            tecnico,
            RRHHAuth,
            MASSAuth,
            imgBlanca,
          });

          const pdfUrl = await generarPDF(
            encabezadoTempo[0],
            detallesTempo,
            Language,
            liberarGerenteSolicita,
            tecnico,
            MASSAuth,
            RRHHAuth,
            solicitaArray,
            RRHHArray,
            MASSArray,
            name,
            direccion,
            logoB64,
            necesitaFirmaRRHH,
            necesitaFirmaMASS,
            cantidadFirmas,
            imgBlanca
          );

          pdfsGenerados.push(pdfUrl);
        }

        setPdfRequisa(pdfsGenerados);
      } catch (error) {
        console.error("ERROR EN obtenerInformacion ReporteRM:", error);
      } finally {
        setLoading(false);
      }
    };

    const calcularCantidadTotal = (detallesTempo) => {
        let cantidadTot = 0;
        detallesTempo.forEach((detalle) => {
          cantidadTot += detalle.Qty;
        });
        return cantidadTot;
    };
  
    const generarPDF = async (
      encabezado,
      detalles,
      Idioma,
      liberarGerenteSolicita,
      tecnico,
      MASSAuth,
      RRHHAuth,
      solicitaArray,
      RRHHArray,
      MASSArray,
      name,
      direccion,
      logoB64,
      necesitaFirmaRRHH,
      necesitaFirmaMASS,
      cantidadFirmas,
      imgBlanca
    ) => {
        setLoading(true)
        // let CodigoQR 
        // QRCode.toDataURL(`${encabezado?.Requisa || ""}`, { errorCorrectionLevel: 'Q' }, (err, url) => {
        //   CodigoQR = url;
        // })
        const CodigoQR = await QRCode.toDataURL(`${encabezado?.Requisa || ""}`, {
          errorCorrectionLevel: "Q",
        });

        const canvas = document.createElement('canvas');
        JsBarcode(canvas, encabezado?.Requisa, {
          format: 'CODE128',
          width: 2,
          height: 80,
          displayValue: false,
        });

        const codigoBarrasURL = canvas.toDataURL('image/png');
        const cantidadTot = calcularCantidadTotal(detalles);

        const docDefinition = {
          pageSize: "LETTER",
          pageOrientation: "portrait",
          pageMargins: [40, 75, 40, 95],

          // HEADER
          header: function (currentPage, pageCount, pageSize) {
            return [
              {
                widths: ["*", "*", "*", "*", "*"],
                columns: [
                  [
                    [
                      logoB64
                        ? {
                            image: logoB64,
                            width: 170,
                            margin: [18, -5, -10, -10],
                          }
                        : {
                            text: "",
                            width: 170,
                            margin: [18, -5, -10, -10],
                          },
                    ],
                  ],
                  [
                    {
                      text:
                        `${getLabel(
                          RequisasMaterialesReporteLang,
                          encabezado?.MateriaPrima === true
                            ? "requisaMP"
                            : "requisaM",
                          Language
                        )}` + "\n",
                      style: "titulo2",
                      margin:
                        encabezado?.MateriaPrima === true
                          ? [-4, 18, 0, 0]
                          : [6, 18, 0, 0],
                      width: 320,
                    },
                    {
                      image: codigoBarrasURL,
                      width: 80,
                      margin: [8, 0, 0, 0],
                    },
                    {
                      text: `${encabezado?.Requisa || ""}`,
                      style: "titulo2",
                      margin: [12, 0, 0, 0],
                      width: 320,
                    },
                  ],
                  [
                    {
                      text:
                        `${getLabel(
                          RequisasMaterialesReporteLang,
                          "fecha",
                          Language
                        )}` +
                        "\n\n" +
                        `${getLabel(
                          RequisasMaterialesReporteLang,
                          "area",
                          Language
                        )}` +
                        "\n\n" +
                        `${getLabel(
                          RequisasMaterialesReporteLang,
                          "solicita",
                          Language
                        )}\n\n`,
                      style: "titulo",
                      margin: [-60, 20, 0, 0],
                      width: 320,
                    },
                  ],
                  [
                    {
                      text:
                        `${getDateString(
                          new Date(encabezado?.FechaEnc || "")
                        )}` +
                        "\n\n" +
                        `${encabezado?.Area || ""}` +
                        "\n\n" +
                        `${encabezado?.UserNameSolicita || ""}\n\n`,
                      style: "titulo",
                      margin: [-190, 20, 0, 0],
                      width: 320,
                    },
                  ],
                  [
                    {
                      text: `${getLabel(
                        RequisasMaterialesReporteLang,
                        "requisitos",
                        Language
                      )}`,
                      style: "textBody",
                      margin: [-560, 18, 20, 0],
                      width: 320,
                    },
                    {
                      text: [
                        "Permiso de salida de bodega (Solicita)\n",
                        RRHHArray.some((item) => item === true)
                          ? "Permiso de salida de bodega (RRHH)\n"
                          : "",
                        MASSArray.some((item) => item === true)
                          ? "Permiso de salida de bodega (MASS)\n"
                          : "",
                      ],
                      style: "textBody2",
                      margin: [-560, 5, 20, 0],
                    },
                  ],
                ],
              },
            ];
          },

          // FOOTER
          footer: (currentPage, pageCount) => {
            return {
              margin: [0, 0, 35, 20],
              columns: [
                {
                  width: "*",
                  text: "",
                },
                {
                  width: 90,
                  table: {
                    widths: [90],
                    body: [
                      [
                        {
                          image: CodigoQR,
                          width: 55,
                          alignment: "center",
                          border: [false, false, false, false],
                          margin: [0, 0, 0, 8],
                        },
                      ],
                      [
                        {
                          text: `${getLabel(
                            RequisasMaterialesReporteLang,
                            "Pagina",
                            Language
                          )} ${currentPage} / ${pageCount}`,
                          fontSize: 7.5,
                          alignment: "center",
                          border: [false, false, false, false],
                          margin: [0, 0, 0, 0],
                        },
                      ],
                    ],
                  },
                  layout: {
                    defaultBorder: false,
                  },
                },
              ],
            };
          },

          // CONTENIDO
          content: [
            {
              columns: [
                {
                  margin: [-10, 25, 0, 0],
                  table: {
                    widths: [45, 40, 115, "*", 45],
                    body: [
                      [
                        {
                          text: `${getLabel(
                            RequisasMaterialesReporteLang,
                            "estado",
                            Language
                          )}`,
                          style: "header",
                        },
                        // {
                        //   text: `${getLabel(RequisasMaterialesReporteLang,"fechaTabla",Language)}`,
                        //   style: "header",
                        // },
                        {
                          text: `${getLabel(
                            RequisasMaterialesReporteLang,
                            "codigo",
                            Language
                          )}`,
                          style: "header",
                        },
                        {
                          text: `${getLabel(
                            RequisasMaterialesReporteLang,
                            "producto",
                            Language
                          )}`,
                          style: "header",
                        },
                        {
                          text: `${getLabel(
                            RequisasMaterialesReporteLang,
                            "posicion",
                            Language
                          )}`,
                          style: "header",
                        },
                        {
                          text: `${getLabel(
                            RequisasMaterialesReporteLang,
                            "cantidad",
                            Language
                          )}`,
                          style: "header",
                        },
                      ],
                      ...detalles.map((d) => [
                        { text: `${d.StatusName || ""}`, style: "textBody1" },
                        // {
                        //   text: `${getDateString(new Date(d.FechaDet || ""))}`,
                        //   style: "textBody1",
                        // },
                        {
                          text: `${d.CodigoProducto || ""}`,
                          style: "textBody1",
                        },
                        {
                          text: `${d.NombreProducto || ""}`,
                          style: "textBody1",
                        },
                        {
                          text: `${d.PosicionProducto || ""}`,
                          style: "textBody1",
                        },
                        {
                          text: formatNumberDecimal(`${d.Qty}`),
                          style: "textBody1",
                        },
                      ]),
                    ],
                  },
                  layout: "lightHorizontalLines",
                },
              ],
            },

            {
              columns: [
                {
                  margin: [430, 10, 0, 0],
                  table: {
                    widths: [40, 45],
                    body: [
                      [
                        { text: `TOTAL`, style: "textTotales" },
                        {
                          text: formatNumberDecimal(`${cantidadTot}`),
                          style: "textBody1",
                        },
                      ],
                    ],
                  },
                  layout: "lightHorizontalLines",
                },
              ],
            },
          ],

          // ESTILOS
          styles: {
            tableExample: {
              margin: [0, 5, 0, 15],
            },
            titulo: {
              fontSize: 8,
              // margin: [0, 50, 0, 0],
              bold: true,
              alignment: "justify",
            },
            titulo2: {
              fontSize: 10,
              // margin: [0, 50, 0, 0],
              bold: true,
              alignment: "justify",
            },
            titulo3: {
              fontSize: 7.5,
              // margin: [0, 50, 0, 0],
              semmibold: true,
              alignment: "justify",
            },
            requisa: {
              fontSize: 15,
              // margin: [0, 50, 0, 0],
              bold: true,
              alignment: "justify",
            },
            numeroDoc: {
              fontSize: 10,
              bold: true,
              alignment: "center",
            },
            infoGeneral: {
              fontSize: 8,
              margin: [-5, 0, 0, 0],
              // bold: true,
              // alignment: 'justify'
            },
            infoProveedor: {
              fontSize: 8,
              margin: [0, 0, 0, 0],
            },
            header: {
              fontSize: 7,
              alignment: "center",
              bold: true,
            },
            headerr: {
              fontSize: 7,
              alignment: "center",
              // bold: true,
            },
            textBody: {
              fontSize: 9,
              alignment: "center",
              bold: true,
              // lineHeight: 2
            },
            textBody1: {
              fontSize: 8,
              alignment: "center",
              // bold: true,
              // lineHeight: 2
            },
            textBody2: {
              fontSize: 7,
              alignment: "center",
            },
            textBody3: {
              fontSize: 7.5,
              alignment: "justify",
              // lineHeight: 2
            },
            textBody4: {
              fontSize: 8.5,
              alignment: "justify",
              // lineHeight: 2
            },
            textTotales: {
              bold: true,
              fontSize: 7.5,
              alignment: "right",
            },
            textCentrado: {
              fontSize: 7.5,
              alignment: "center",
            },
            firmas: {
              fontSize: 8,
              bold: true,
              alignment: "center",
              lineHeight: 1,
            },
            footer: {
              fontSize: 7.5,
              alignment: "left",
              margin: [30, 0, 5, 0],
            },
          },
        };

        const generarContenidoFirmas = () => {
          switch (cantidadFirmas) {
            case 0:
              return {
                columns: [
                  {
                    margin: [-10, 75, 0, 0],
                    layout: { defaultBorder: false },
                    table: {
                      widths: ["*", "*", "*"],
                      headerRows: 2,
                      body: [
                        //COMENTARIO
                        [
                          {
                            text: `Comentario:  ${ encabezado?.Comentarios || ""}`,
                            style: "titulo",
                            colSpan: 3,
                            margin: [0, -80, 0, 150],
                          },
                          {},
                          {},
                        ],
                        // FIRMA DE GERENTE SOLICITA
                        [
                          [
                            liberarGerenteSolicita || imgBlanca
                            ? {
                                image: liberarGerenteSolicita || imgBlanca,
                                width: 150,
                                height: 130,
                                margin: [25, 0, -50, -30],
                              }
                            : {
                                text: "",
                                width: 150,
                                height: 130,
                                margin: [25, 0, -50, -30],
                              },
                            {
                              border: [false, true, false, false],
                              text: `\n  _______________________________________ \n${getLabel( RequisasMaterialesReporteLang, "firmaAutoriza", Language)}${detalles[0]?.UserNameAutorizoSolicita || ""}\n\n`,
                              style: "firmas",
                              width: [120],
                              margin: [-25, 0, -50, -30],
                            },
                          ],

                          { text: "" },

                          [
                            tecnico || imgBlanca
                              ? {
                                  image: tecnico || imgBlanca,
                                  width: 150,
                                  height: 120,
                                  margin: [0, 0, -59, -30],
                                }
                              : {
                                  text: "",
                                  width: 150,
                                  height: 130,
                                  margin: [25, 0, -50, -30],
                                },
                            {
                              border: [false, true, false, false],
                              text: `\n  _______________________________________ \n${getLabel(
                                RequisasMaterialesReporteLang,
                                "tecnico",
                                Language
                              )}`,
                              style: "firmas",
                              width: [120],
                              margin: [0, 0, 0, 0],
                            },
                          ],
                        ],
                        // FIRMA DEL QUE RECIBE
                        [
                          { text: "" },

                          [
                            imgBlanca
                            ? {
                                image: imgBlanca,
                                width: 150,
                                height: 130,
                                margin: [0, 0, -50, -30],
                              }
                            : {
                                text: "",
                                margin: [0, 0, 0, 0],
                              },
                            {
                              border: [false, true, false, false],
                              text: `\n  _______________________________________ \n${getLabel(
                                RequisasMaterialesReporteLang,
                                "recibidoPor",
                                Language
                              )}`,
                              style: "firmas",
                              width: [120],
                            },
                          ],

                          { text: "" },
                        ],
                      ],
                    },
                  },
                ],
              };
            case 1:
              return {
                columns: [
                  {
                    margin: [-10, 75, 0, 0],
                    layout: { defaultBorder: false },
                    table: {
                      widths: ["*", 15, "*", 15, "*"],
                      headerRows: 2,
                      body: [
                        // COMENTARIO
                        [
                          {
                            text: `Comentario:  ${
                              encabezado?.Comentarios || ""
                            }`,
                            style: "titulo",
                            colSpan: 5,
                            margin: [0, -80, 0, 60],
                          },
                          {},
                          {},
                          {},
                          {},
                        ],
                        // FIRMA
                        [
                          // FIRMA DE GERENTE
                          [
                            liberarGerenteSolicita || imgBlanca
                            ? {
                                image: liberarGerenteSolicita || imgBlanca,
                                width: 150,
                                height: 130,
                                margin: [25, 0, -50, -30],
                              }
                            : {
                                text: "",
                                width: 150,
                                height: 130,
                                margin: [25, 0, -50, -30],
                              },
                            {
                              border: [false, true, false, false],
                              text: `\n  _______________________________________ \n${getLabel(
                                RequisasMaterialesReporteLang,
                                "firmaAutoriza",
                                Language
                              )} ${
                                detalles[0]?.UserNameAutorizoSolicita || ""
                              }\n\n`,
                              style: "firmas",
                              width: [120],
                              margin: [-25, 0, -50, -30],
                            },
                          ],
                          { text: "" },
                          // FIRMA DE TECNICO
                          [
                            tecnico || imgBlanca
                              ? {
                                  image: tecnico || imgBlanca,
                                  width: 150,
                                  height: 120,
                                  margin: [0, 0, -59, -30],
                                }
                              : {
                                  text: "",
                                  width: 150,
                                  height: 130,
                                  margin: [25, 0, -50, -30],
                                },
                            {
                              border: [false, true, false, false],
                              text: `\n  _______________________________________ \n${getLabel(
                                RequisasMaterialesReporteLang,
                                "tecnico",
                                Language
                              )}`,
                              style: "firmas",
                              width: [120],
                              margin: [0, 0, 0, 0],
                            },
                          ],
                          { text: "" },
                          // FIRMA RRHH Y MASS
                          necesitaFirmaRRHH
                            ? [
                                necesitaFirmaRRHH
                                ? (RRHHAuth || imgBlanca)
                                  ? {
                                      image: RRHHAuth || imgBlanca,
                                      width: 150,
                                      height: 130,
                                      margin: [0, 0, -50, -30],
                                    }
                                  : {
                                      text: "",
                                      margin: [-20, 115, -10, -10],
                                    }
                                : {
                                    text: "",
                                    margin: [-20, 115, -10, -10],
                                  },
                                necesitaFirmaRRHH
                                  ? {
                                      border: [false, true, false, false],
                                      text: `\n  _______________________________________ \n${getLabel(
                                        RequisasMaterialesReporteLang,
                                        "RRHH",
                                        Language
                                      )}  
                            ${detalles[0]?.UserNameAutorizoRRHH || ""}\n\n`,
                                      style: "firmas",
                                      width: [120],
                                    }
                                  : {
                                      border: [false, true, false, false],
                                      text: "",
                                      style: "firmas",
                                      width: [120],
                                    },
                              ]
                            : [
                                necesitaFirmaMASS
                                ? (MASSAuth || imgBlanca)
                                  ? {
                                      image: MASSAuth || imgBlanca,
                                      width: 150,
                                      height: 130,
                                      margin: [0, 0, -50, -30],
                                    }
                                  : {
                                      text: "",
                                      margin: [-20, 115, -10, -10],
                                    }
                                : {
                                    text: "",
                                    margin: [-20, 115, -10, -10],
                                  },
                                necesitaFirmaMASS
                                  ? {
                                      border: [false, true, false, false],
                                      text: `\n  _______________________________________ \n${getLabel(
                                        RequisasMaterialesReporteLang,
                                        "MASS",
                                        Language
                                      )}  
                            ${detalles[0]?.UserNameAutorizoMASS || ""}\n\n `,
                                      style: "firmas",
                                      width: [120],
                                    }
                                  : {
                                      border: [false, true, false, false],
                                      text: "",
                                      style: "firmas",
                                      width: [120],
                                    },
                              ],
                        ],
                        // FIRMA DEL QUE RECIBE
                        [
                          { text: "" },
                          { text: "" },

                          [
                            imgBlanca
                            ? {
                                image: imgBlanca,
                                width: 150,
                                height: 130,
                                margin: [0, 0, -50, -30],
                              }
                            : {
                                text: "",
                                margin: [0, 0, 0, 0],
                              },
                            {
                              border: [false, true, false, false],
                              text: `\n  _______________________________________ \n${getLabel(
                                RequisasMaterialesReporteLang,
                                "recibidoPor",
                                Language
                              )}`,
                              style: "firmas",
                              width: [120],
                            },
                          ],

                          { text: "" },
                          { text: "" },
                        ],
                      ],
                    },
                  },
                ],
              };
            case 2:
              return {
                columns: [
                  {
                    margin: [-10, 75, 0, 0],
                    layout: { defaultBorder: false },
                    table: {
                      widths: ["*", 15, "*", 15, "*"],
                      headerRows: 2,
                      body: [
                        // COMENTARIO 
                        [
                          {
                            text: `Comentario:  ${
                              encabezado?.Comentarios || ""
                            }`,
                            style: "titulo",
                            colSpan: 5,
                            margin: [0, -80, 0, 60],
                          },
                          {},
                          {},
                          {},
                          {},
                        ],
                        // FIRMAS
                        [
                          // FIRMA DE GERENTE
                          [
                            liberarGerenteSolicita || imgBlanca
                            ? {
                                image: liberarGerenteSolicita || imgBlanca,
                                width: 150,
                                height: 130,
                                margin: [25, 0, -50, -30],
                              }
                            : {
                                text: "",
                                margin: [-25, 0, -50, -30],
                              },
                            {
                              border: [false, true, false, false],
                              text: `\n  _______________________________________ \n${getLabel(
                                RequisasMaterialesReporteLang,
                                "firmaAutoriza",
                                Language
                              )}
                          ${detalles[0]?.UserNameAutorizoSolicita || ""}\n\n`,
                              style: "firmas",
                              width: [120],
                              margin: [-25, 0, -50, -30],
                            },
                          ],
                          { text: "" },
                          // FIRMA DE MASS
                          [
                            necesitaFirmaMASS
                            ? (MASSAuth || imgBlanca)
                              ? {
                                  image: MASSAuth || imgBlanca,
                                  width: 150,
                                  height: 130,
                                  margin: [0, 0, -50, -30],
                                }
                              : {
                                  text: "",
                                  margin: [-20, 115, -10, -10],
                                }
                            : {
                                text: "",
                                margin: [-20, 115, -10, -10],
                              },
                            necesitaFirmaMASS
                              ? {
                                  border: [false, true, false, false],
                                  text: `\n  _______________________________________ \n${getLabel(
                                    RequisasMaterialesReporteLang,
                                    "MASS",
                                    Language
                                  )}  
                              ${detalles[0]?.UserNameAutorizoMASS || ""}\n\n `,
                                  style: "firmas",
                                  width: [120],
                                }
                              : {
                                  border: [false, true, false, false],
                                  text: "",
                                  style: "firmas",
                                  width: [120],
                                },
                          ],
                          { text: "" },
                          // FIRMA DE RRHH
                          [
                            necesitaFirmaRRHH
                            ? (RRHHAuth || imgBlanca)
                              ? {
                                  image: RRHHAuth || imgBlanca,
                                  width: 150,
                                  height: 130,
                                  margin: [0, 0, -50, -30],
                                }
                              : {
                                  text: "",
                                  margin: [-20, 115, -10, -10],
                                }
                            : {
                                text: "",
                                margin: [-20, 115, -10, -10],
                              },
                            necesitaFirmaRRHH
                              ? {
                                  border: [false, true, false, false],
                                  text: `\n  _______________________________________ \n${getLabel(
                                    RequisasMaterialesReporteLang,
                                    "RRHH",
                                    Language
                                  )}  
                              ${detalles[0]?.UserNameAutorizoRRHH || ""}\n\n`,
                                  style: "firmas",
                                  width: [120],
                                }
                              : {
                                  border: [false, true, false, false],
                                  text: "",
                                  style: "firmas",
                                  width: [120],
                                },
                          ],
                        ],
                      ],
                    },
                  },
                ],
              };
            default:
              return null;
          }
        };

        const dosfirmas = ()=>{
          return{
            columns:[
              {
                layout: {defaultBorder: false},
                table: {
                  widths: ['*', 15, '*'],
                  body:[
                    [
                      [
                        tecnico || imgBlanca
                          ? {
                              image: tecnico || imgBlanca,
                              width: 150,
                              height: 120,
                              margin: [0, 0, -59, -30],
                            }
                          : {
                              text: "",
                              margin: [0, 0, -10, -10],
                            },
                        {
                        text: `\n  _______________________________________ \n${getLabel( RequisasMaterialesReporteLang, "tecnico", Language )}`,
                        style: "firmas",
                        width: [120],
                        },
                      ],
                      { text: "" },
                      [
                        { text: "", margin: [0, 0, 0, 0] },
                        {
                          margin: [0, 100, 0, 0],
                          text: `\n  _______________________________________ \n${getLabel( RequisasMaterialesReporteLang, "recibidoPor", Language )}`,
                          style: "firmas",
                          width: [120],
                        },
                      ],
                    ],
                  ]
                }
              }
            ]
          }
        }

        const firmas = generarContenidoFirmas()
        const dosFirmas = dosfirmas()

        // FIRMAS
        docDefinition.content.push(firmas)

        if(cantidadFirmas === 2){
          docDefinition.content.push(dosFirmas)
        }

        const doc = pdfMake.createPdf(docDefinition);

        return await new Promise((resolve) => {
          doc.getDataUrl((url) => {
            resolve(url);
          });
           
        });
        setLoading(false)

    };

    const combinarPDFs = async (pdfs) => {
      if (!pdfs || pdfs.length === 0) return;

      const pdfDoc = await PDFDocument.create();

      for (const pdfBase64 of pdfs) {
        const pdfBytes = await fetch(pdfBase64).then((res) => res.arrayBuffer());
        const pdfDocTemp = await PDFDocument.load(pdfBytes);
        const pages = await pdfDoc.copyPages(
          pdfDocTemp,
          pdfDocTemp.getPageIndices()
        );

        pages.forEach((page) => pdfDoc.addPage(page));
      }

      const mergedPdfBytes = await pdfDoc.save();
      const blob = new Blob([mergedPdfBytes], { type: "application/pdf" });
      const blobUrl = URL.createObjectURL(blob);

      setPdfUrlCombinado(blobUrl);
    };

    useEffect(() => {
      if (pdfRequisa && pdfRequisa.length > 0) {
        combinarPDFs(pdfRequisa);
      }
    }, [pdfRequisa]);

    useEffect(() => {
      if (showReporte) {
        obtenerInformacion();
      }
    }, [showReporte]);
  
    const onHideReporte = () => {
      setShowReporte(false);
      getInfo()
      setLanguaje('es')
    };
  
    return (
      <Dialog
        visible={showReporte}
        onHide={onHideReporte}
        style={{ width: "63vw", height: "85vh" }}
      >
        <Loader loading={loading}/>
        <Toast ref={toast} />
        <div>
          {!loading && pdfUrlCombinado && (
            <iframe
              src={pdfUrlCombinado}
              style={{ width: "60vw", height: "75vh", border: "1px solid #ccc" }}
              id="foo"
              title="Reporte QR PDF"
            />
          )}
        </div>
      </Dialog>
    );
  };
  
  export default ReporteRM;
  